const sanitizeCacheSegment = (value) =>
  String(value || 'anonymous')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '_');

export const getGreArticleCacheScope = (user) => {
  if (!user || typeof user !== 'object') {
    return 'anonymous';
  }

  if (user.id !== undefined && user.id !== null && user.id !== '') {
    return `id_${sanitizeCacheSegment(user.id)}`;
  }

  if (user.email) {
    return `email_${sanitizeCacheSegment(user.email)}`;
  }

  return 'anonymous';
};

export const getGreArticleCacheKey = (user, articleRef) =>
  `gre_article_cache_${getGreArticleCacheScope(user)}_${sanitizeCacheSegment(articleRef)}`;

export const getGreArticleExercisesCacheKey = (user, articleRef) =>
  `gre_article_exercises_cache_${getGreArticleCacheScope(user)}_${sanitizeCacheSegment(articleRef)}`;
